// @ts-nocheck
/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: string; output: string; }
  BigInt: { input: string; output: string; }
  Bytes: { input: any; output: any; }
  /**
   * 8 bytes signed integer
   *
   */
  Int8: { input: any; output: any; }
  /**
   * A string representation of microseconds UNIX timestamp (16 digits)
   *
   */
  Timestamp: { input: any; output: any; }
};

export enum Aggregation_Interval {
  Day = 'day',
  Hour = 'hour'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type Bundle = {
  __typename?: 'Bundle';
  ethPriceUSD: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
};

export type Bundle_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Bundle_Filter>>>;
  ethPriceUSD?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  ethPriceUSD_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Bundle_Filter>>>;
};

export enum Bundle_OrderBy {
  EthPriceUsd = 'ethPriceUSD',
  Id = 'id'
}

export type Composition = {
  __typename?: 'Composition';
  id: Scalars['ID']['output'];
  lendingToken0: Scalars['BigInt']['output'];
  lendingToken1: Scalars['BigInt']['output'];
  poolToken0: Scalars['BigInt']['output'];
  poolToken1: Scalars['BigInt']['output'];
  vaultToken0: Scalars['BigInt']['output'];
  vaultToken1: Scalars['BigInt']['output'];
};

export type Composition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Composition_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lendingToken0?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lendingToken0_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_not?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lendingToken1?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lendingToken1_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_not?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Composition_Filter>>>;
  poolToken0?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolToken0_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolToken1?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolToken1_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vaultToken0?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vaultToken0_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_not?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vaultToken1?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vaultToken1_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_not?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Composition_OrderBy {
  Id = 'id',
  LendingToken0 = 'lendingToken0',
  LendingToken1 = 'lendingToken1',
  PoolToken0 = 'poolToken0',
  PoolToken1 = 'poolToken1',
  VaultToken0 = 'vaultToken0',
  VaultToken1 = 'vaultToken1'
}

export type DopexVault = {
  __typename?: 'DopexVault';
  decimals: Scalars['BigInt']['output'];
  depositCap: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  isTokenPairReversed: Scalars['Boolean']['output'];
  pool: Scalars['String']['output'];
  rate: Scalars['BigDecimal']['output'];
  totalAssets: Scalars['BigInt']['output'];
  totalSupply: Scalars['BigInt']['output'];
  yieldStart: Scalars['BigInt']['output'];
};

export type DopexVault_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DopexVault_Filter>>>;
  decimals?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  decimals_lt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_lte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositCap?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositCap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isTokenPairReversed?: InputMaybe<Scalars['Boolean']['input']>;
  isTokenPairReversed_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isTokenPairReversed_not?: InputMaybe<Scalars['Boolean']['input']>;
  isTokenPairReversed_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DopexVault_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  rate_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalAssets?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  yieldStart?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  yieldStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum DopexVault_OrderBy {
  Decimals = 'decimals',
  DepositCap = 'depositCap',
  Id = 'id',
  IsTokenPairReversed = 'isTokenPairReversed',
  Pool = 'pool',
  Rate = 'rate',
  TotalAssets = 'totalAssets',
  TotalSupply = 'totalSupply',
  YieldStart = 'yieldStart'
}

export type GlobalState = {
  __typename?: 'GlobalState';
  dnClassicVaults: Array<Scalars['ID']['output']>;
  dopexAutomaterVaults: Array<Scalars['ID']['output']>;
  ethPriceUSD: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  lpManagers: Array<Scalars['ID']['output']>;
  tvl: Scalars['BigDecimal']['output'];
};

export type GlobalState_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<GlobalState_Filter>>>;
  dnClassicVaults?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_not?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_not_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_not_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_not?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_not_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_not_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  ethPriceUSD?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  ethPriceUSD_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_not?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_not_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_not_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<GlobalState_Filter>>>;
  tvl?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tvl_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum GlobalState_OrderBy {
  DnClassicVaults = 'dnClassicVaults',
  DopexAutomaterVaults = 'dopexAutomaterVaults',
  EthPriceUsd = 'ethPriceUSD',
  Id = 'id',
  LpManagers = 'lpManagers',
  Tvl = 'tvl'
}

export type HandlerReservedLiquidity = {
  __typename?: 'HandlerReservedLiquidity';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  helper: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  tokenId: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type HandlerReservedLiquidity_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<HandlerReservedLiquidity_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  helper?: InputMaybe<Scalars['String']['input']>;
  helper_contains?: InputMaybe<Scalars['String']['input']>;
  helper_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_ends_with?: InputMaybe<Scalars['String']['input']>;
  helper_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_gt?: InputMaybe<Scalars['String']['input']>;
  helper_gte?: InputMaybe<Scalars['String']['input']>;
  helper_in?: InputMaybe<Array<Scalars['String']['input']>>;
  helper_lt?: InputMaybe<Scalars['String']['input']>;
  helper_lte?: InputMaybe<Scalars['String']['input']>;
  helper_not?: InputMaybe<Scalars['String']['input']>;
  helper_not_contains?: InputMaybe<Scalars['String']['input']>;
  helper_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  helper_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  helper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  helper_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_starts_with?: InputMaybe<Scalars['String']['input']>;
  helper_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<HandlerReservedLiquidity_Filter>>>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
  tokenId_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_gt?: InputMaybe<Scalars['String']['input']>;
  tokenId_gte?: InputMaybe<Scalars['String']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['String']['input']>;
  tokenId_lte?: InputMaybe<Scalars['String']['input']>;
  tokenId_not?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum HandlerReservedLiquidity_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Helper = 'helper',
  Id = 'id',
  Liquidity = 'liquidity',
  TokenId = 'tokenId',
  User = 'user'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Pool = {
  __typename?: 'Pool';
  id: Scalars['ID']['output'];
  sqrtPrice: Scalars['BigInt']['output'];
  tick: Scalars['BigInt']['output'];
  token0: Token;
  token0Price: Scalars['BigDecimal']['output'];
  token1: Token;
  token1Price: Scalars['BigDecimal']['output'];
};

export type Pool_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Pool_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Pool_Filter>>>;
  sqrtPrice?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPrice_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tick?: InputMaybe<Scalars['BigInt']['input']>;
  tick_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tick_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tick_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tick_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tick_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tick_not?: InputMaybe<Scalars['BigInt']['input']>;
  tick_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  token0?: InputMaybe<Scalars['String']['input']>;
  token0Price?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  token0Price_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  token0_?: InputMaybe<Token_Filter>;
  token0_contains?: InputMaybe<Scalars['String']['input']>;
  token0_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_gt?: InputMaybe<Scalars['String']['input']>;
  token0_gte?: InputMaybe<Scalars['String']['input']>;
  token0_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_lt?: InputMaybe<Scalars['String']['input']>;
  token0_lte?: InputMaybe<Scalars['String']['input']>;
  token0_not?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1?: InputMaybe<Scalars['String']['input']>;
  token1Price?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  token1Price_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  token1_?: InputMaybe<Token_Filter>;
  token1_contains?: InputMaybe<Scalars['String']['input']>;
  token1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_gt?: InputMaybe<Scalars['String']['input']>;
  token1_gte?: InputMaybe<Scalars['String']['input']>;
  token1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_lt?: InputMaybe<Scalars['String']['input']>;
  token1_lte?: InputMaybe<Scalars['String']['input']>;
  token1_not?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Pool_OrderBy {
  Id = 'id',
  SqrtPrice = 'sqrtPrice',
  Tick = 'tick',
  Token0 = 'token0',
  Token0Price = 'token0Price',
  Token0Decimals = 'token0__decimals',
  Token0DerivedEth = 'token0__derivedETH',
  Token0Id = 'token0__id',
  Token0Name = 'token0__name',
  Token0Symbol = 'token0__symbol',
  Token1 = 'token1',
  Token1Price = 'token1Price',
  Token1Decimals = 'token1__decimals',
  Token1DerivedEth = 'token1__derivedETH',
  Token1Id = 'token1__id',
  Token1Name = 'token1__name',
  Token1Symbol = 'token1__symbol'
}

export type Position = {
  __typename?: 'Position';
  id: Scalars['ID']['output'];
  share: Scalars['BigInt']['output'];
  vault: Scalars['String']['output'];
};

export type Position_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Position_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Position_Filter>>>;
  share?: InputMaybe<Scalars['BigInt']['input']>;
  share_gt?: InputMaybe<Scalars['BigInt']['input']>;
  share_gte?: InputMaybe<Scalars['BigInt']['input']>;
  share_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  share_lt?: InputMaybe<Scalars['BigInt']['input']>;
  share_lte?: InputMaybe<Scalars['BigInt']['input']>;
  share_not?: InputMaybe<Scalars['BigInt']['input']>;
  share_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vault?: InputMaybe<Scalars['String']['input']>;
  vault_contains?: InputMaybe<Scalars['String']['input']>;
  vault_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_ends_with?: InputMaybe<Scalars['String']['input']>;
  vault_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_gt?: InputMaybe<Scalars['String']['input']>;
  vault_gte?: InputMaybe<Scalars['String']['input']>;
  vault_in?: InputMaybe<Array<Scalars['String']['input']>>;
  vault_lt?: InputMaybe<Scalars['String']['input']>;
  vault_lte?: InputMaybe<Scalars['String']['input']>;
  vault_not?: InputMaybe<Scalars['String']['input']>;
  vault_not_contains?: InputMaybe<Scalars['String']['input']>;
  vault_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  vault_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  vault_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  vault_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_starts_with?: InputMaybe<Scalars['String']['input']>;
  vault_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Position_OrderBy {
  Id = 'id',
  Share = 'share',
  Vault = 'vault'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  bundle?: Maybe<Bundle>;
  bundles: Array<Bundle>;
  composition?: Maybe<Composition>;
  compositions: Array<Composition>;
  dopexVault?: Maybe<DopexVault>;
  dopexVaults: Array<DopexVault>;
  globalState?: Maybe<GlobalState>;
  globalStates: Array<GlobalState>;
  handlerReservedLiquidities: Array<HandlerReservedLiquidity>;
  handlerReservedLiquidity?: Maybe<HandlerReservedLiquidity>;
  pool?: Maybe<Pool>;
  pools: Array<Pool>;
  position?: Maybe<Position>;
  positions: Array<Position>;
  rebalance?: Maybe<Rebalance>;
  rebalances: Array<Rebalance>;
  reservedLiquidities: Array<ReservedLiquidity>;
  reservedLiquidity?: Maybe<ReservedLiquidity>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
  user?: Maybe<User>;
  users: Array<User>;
  valueComposition?: Maybe<ValueComposition>;
  valueCompositions: Array<ValueComposition>;
  vault?: Maybe<Vault>;
  vaults: Array<Vault>;
  workingEarnedFee?: Maybe<WorkingEarnedFee>;
  workingEarnedFees: Array<WorkingEarnedFee>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryBundleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryBundlesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Bundle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Bundle_Filter>;
};


export type QueryCompositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryCompositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Composition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Composition_Filter>;
};


export type QueryDopexVaultArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDopexVaultsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DopexVault_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DopexVault_Filter>;
};


export type QueryGlobalStateArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryGlobalStatesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GlobalState_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<GlobalState_Filter>;
};


export type QueryHandlerReservedLiquiditiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HandlerReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<HandlerReservedLiquidity_Filter>;
};


export type QueryHandlerReservedLiquidityArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Pool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Pool_Filter>;
};


export type QueryPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Position_Filter>;
};


export type QueryRebalanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRebalancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Rebalance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Rebalance_Filter>;
};


export type QueryReservedLiquiditiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ReservedLiquidity_Filter>;
};


export type QueryReservedLiquidityArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};


export type QueryUserArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryUsersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<User_Filter>;
};


export type QueryValueCompositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryValueCompositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ValueComposition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ValueComposition_Filter>;
};


export type QueryVaultArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryVaultsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Vault_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Vault_Filter>;
};


export type QueryWorkingEarnedFeeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryWorkingEarnedFeesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorkingEarnedFee_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WorkingEarnedFee_Filter>;
};

export type Rebalance = {
  __typename?: 'Rebalance';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  rate: Scalars['BigDecimal']['output'];
  totalAssets: Scalars['BigInt']['output'];
  totalSupply: Scalars['BigInt']['output'];
  vault: Scalars['String']['output'];
};

export type Rebalance_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Rebalance_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Rebalance_Filter>>>;
  rate?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  rate_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalAssets?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vault?: InputMaybe<Scalars['String']['input']>;
  vault_contains?: InputMaybe<Scalars['String']['input']>;
  vault_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_ends_with?: InputMaybe<Scalars['String']['input']>;
  vault_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_gt?: InputMaybe<Scalars['String']['input']>;
  vault_gte?: InputMaybe<Scalars['String']['input']>;
  vault_in?: InputMaybe<Array<Scalars['String']['input']>>;
  vault_lt?: InputMaybe<Scalars['String']['input']>;
  vault_lte?: InputMaybe<Scalars['String']['input']>;
  vault_not?: InputMaybe<Scalars['String']['input']>;
  vault_not_contains?: InputMaybe<Scalars['String']['input']>;
  vault_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  vault_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  vault_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  vault_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_starts_with?: InputMaybe<Scalars['String']['input']>;
  vault_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Rebalance_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  Rate = 'rate',
  TotalAssets = 'totalAssets',
  TotalSupply = 'totalSupply',
  Vault = 'vault'
}

export type ReservedLiquidity = {
  __typename?: 'ReservedLiquidity';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  handler: Scalars['String']['output'];
  helper: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  pool: Scalars['String']['output'];
  tickLower: Scalars['BigInt']['output'];
  tickUpper: Scalars['BigInt']['output'];
  tokenId: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type ReservedLiquidity_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ReservedLiquidity_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper?: InputMaybe<Scalars['String']['input']>;
  helper_contains?: InputMaybe<Scalars['String']['input']>;
  helper_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_ends_with?: InputMaybe<Scalars['String']['input']>;
  helper_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_gt?: InputMaybe<Scalars['String']['input']>;
  helper_gte?: InputMaybe<Scalars['String']['input']>;
  helper_in?: InputMaybe<Array<Scalars['String']['input']>>;
  helper_lt?: InputMaybe<Scalars['String']['input']>;
  helper_lte?: InputMaybe<Scalars['String']['input']>;
  helper_not?: InputMaybe<Scalars['String']['input']>;
  helper_not_contains?: InputMaybe<Scalars['String']['input']>;
  helper_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  helper_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  helper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  helper_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_starts_with?: InputMaybe<Scalars['String']['input']>;
  helper_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ReservedLiquidity_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tickLower?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickLower_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_not?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickUpper?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickUpper_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_not?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
  tokenId_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_gt?: InputMaybe<Scalars['String']['input']>;
  tokenId_gte?: InputMaybe<Scalars['String']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['String']['input']>;
  tokenId_lte?: InputMaybe<Scalars['String']['input']>;
  tokenId_not?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum ReservedLiquidity_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Handler = 'handler',
  Helper = 'helper',
  Id = 'id',
  Liquidity = 'liquidity',
  Pool = 'pool',
  TickLower = 'tickLower',
  TickUpper = 'tickUpper',
  TokenId = 'tokenId',
  User = 'user'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  bundle?: Maybe<Bundle>;
  bundles: Array<Bundle>;
  composition?: Maybe<Composition>;
  compositions: Array<Composition>;
  dopexVault?: Maybe<DopexVault>;
  dopexVaults: Array<DopexVault>;
  globalState?: Maybe<GlobalState>;
  globalStates: Array<GlobalState>;
  handlerReservedLiquidities: Array<HandlerReservedLiquidity>;
  handlerReservedLiquidity?: Maybe<HandlerReservedLiquidity>;
  pool?: Maybe<Pool>;
  pools: Array<Pool>;
  position?: Maybe<Position>;
  positions: Array<Position>;
  rebalance?: Maybe<Rebalance>;
  rebalances: Array<Rebalance>;
  reservedLiquidities: Array<ReservedLiquidity>;
  reservedLiquidity?: Maybe<ReservedLiquidity>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
  user?: Maybe<User>;
  users: Array<User>;
  valueComposition?: Maybe<ValueComposition>;
  valueCompositions: Array<ValueComposition>;
  vault?: Maybe<Vault>;
  vaults: Array<Vault>;
  workingEarnedFee?: Maybe<WorkingEarnedFee>;
  workingEarnedFees: Array<WorkingEarnedFee>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionBundleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionBundlesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Bundle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Bundle_Filter>;
};


export type SubscriptionCompositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionCompositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Composition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Composition_Filter>;
};


export type SubscriptionDopexVaultArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDopexVaultsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DopexVault_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DopexVault_Filter>;
};


export type SubscriptionGlobalStateArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionGlobalStatesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GlobalState_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<GlobalState_Filter>;
};


export type SubscriptionHandlerReservedLiquiditiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HandlerReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<HandlerReservedLiquidity_Filter>;
};


export type SubscriptionHandlerReservedLiquidityArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Pool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Pool_Filter>;
};


export type SubscriptionPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Position_Filter>;
};


export type SubscriptionRebalanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionRebalancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Rebalance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Rebalance_Filter>;
};


export type SubscriptionReservedLiquiditiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ReservedLiquidity_Filter>;
};


export type SubscriptionReservedLiquidityArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};


export type SubscriptionUserArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionUsersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<User_Filter>;
};


export type SubscriptionValueCompositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionValueCompositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ValueComposition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ValueComposition_Filter>;
};


export type SubscriptionVaultArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionVaultsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Vault_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Vault_Filter>;
};


export type SubscriptionWorkingEarnedFeeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionWorkingEarnedFeesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorkingEarnedFee_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WorkingEarnedFee_Filter>;
};

export type Token = {
  __typename?: 'Token';
  decimals: Scalars['BigInt']['output'];
  derivedETH: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type Token_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  decimals?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  decimals_lt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_lte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  derivedETH?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  derivedETH_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Token_OrderBy {
  Decimals = 'decimals',
  DerivedEth = 'derivedETH',
  Id = 'id',
  Name = 'name',
  Symbol = 'symbol'
}

export type User = {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  positions: Array<Position>;
  reservedLiquidities: Array<ReservedLiquidity>;
};


export type UserPositionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Position_Filter>;
};


export type UserReservedLiquiditiesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReservedLiquidity_Filter>;
};

export type User_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<User_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<User_Filter>>>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_?: InputMaybe<Position_Filter>;
  positions_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_not?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_?: InputMaybe<ReservedLiquidity_Filter>;
  reservedLiquidities_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_not?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum User_OrderBy {
  Id = 'id',
  Positions = 'positions',
  ReservedLiquidities = 'reservedLiquidities'
}

export type ValueComposition = {
  __typename?: 'ValueComposition';
  id: Scalars['ID']['output'];
  lendingToken0: Scalars['BigDecimal']['output'];
  lendingToken1: Scalars['BigDecimal']['output'];
  poolToken0: Scalars['BigDecimal']['output'];
  poolToken1: Scalars['BigDecimal']['output'];
  totalAmountEth: Scalars['BigDecimal']['output'];
  vaultToken0: Scalars['BigDecimal']['output'];
  vaultToken1: Scalars['BigDecimal']['output'];
};

export type ValueComposition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ValueComposition_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lendingToken0?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  lendingToken0_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  lendingToken1?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  lendingToken1_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ValueComposition_Filter>>>;
  poolToken0?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolToken0_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolToken1?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolToken1_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalAmountEth?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalAmountEth_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  vaultToken0?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  vaultToken0_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  vaultToken1?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  vaultToken1_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum ValueComposition_OrderBy {
  Id = 'id',
  LendingToken0 = 'lendingToken0',
  LendingToken1 = 'lendingToken1',
  PoolToken0 = 'poolToken0',
  PoolToken1 = 'poolToken1',
  TotalAmountEth = 'totalAmountEth',
  VaultToken0 = 'vaultToken0',
  VaultToken1 = 'vaultToken1'
}

export type Vault = {
  __typename?: 'Vault';
  decimals: Scalars['BigInt']['output'];
  depositCap: Scalars['BigInt']['output'];
  feeAPR: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  isTokenPairReversed: Scalars['Boolean']['output'];
  lastTimeCollect: Scalars['BigInt']['output'];
  parameter: Scalars['String']['output'];
  pool: Pool;
  rate: Scalars['BigDecimal']['output'];
  receiptTokenUSDValue: Scalars['BigDecimal']['output'];
  tokenComposition: Composition;
  totalAssets: Scalars['BigInt']['output'];
  totalFeeUSD: Scalars['BigDecimal']['output'];
  totalSupply: Scalars['BigInt']['output'];
  tvl: Scalars['BigDecimal']['output'];
  valueComposition: ValueComposition;
  yieldStart: Scalars['BigInt']['output'];
};

export type Vault_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Vault_Filter>>>;
  decimals?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  decimals_lt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_lte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositCap?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositCap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeAPR?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  feeAPR_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isTokenPairReversed?: InputMaybe<Scalars['Boolean']['input']>;
  isTokenPairReversed_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isTokenPairReversed_not?: InputMaybe<Scalars['Boolean']['input']>;
  isTokenPairReversed_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  lastTimeCollect?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastTimeCollect_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Vault_Filter>>>;
  parameter?: InputMaybe<Scalars['String']['input']>;
  parameter_contains?: InputMaybe<Scalars['String']['input']>;
  parameter_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_ends_with?: InputMaybe<Scalars['String']['input']>;
  parameter_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_gt?: InputMaybe<Scalars['String']['input']>;
  parameter_gte?: InputMaybe<Scalars['String']['input']>;
  parameter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  parameter_lt?: InputMaybe<Scalars['String']['input']>;
  parameter_lte?: InputMaybe<Scalars['String']['input']>;
  parameter_not?: InputMaybe<Scalars['String']['input']>;
  parameter_not_contains?: InputMaybe<Scalars['String']['input']>;
  parameter_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  parameter_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  parameter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  parameter_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_starts_with?: InputMaybe<Scalars['String']['input']>;
  parameter_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<Pool_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  rate_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  receiptTokenUSDValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  receiptTokenUSDValue_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenComposition?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_?: InputMaybe<Composition_Filter>;
  tokenComposition_contains?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_gt?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_gte?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenComposition_lt?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_lte?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenComposition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalAssets?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalFeeUSD?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalFeeUSD_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tvl?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tvl_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  valueComposition?: InputMaybe<Scalars['String']['input']>;
  valueComposition_?: InputMaybe<ValueComposition_Filter>;
  valueComposition_contains?: InputMaybe<Scalars['String']['input']>;
  valueComposition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_ends_with?: InputMaybe<Scalars['String']['input']>;
  valueComposition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_gt?: InputMaybe<Scalars['String']['input']>;
  valueComposition_gte?: InputMaybe<Scalars['String']['input']>;
  valueComposition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  valueComposition_lt?: InputMaybe<Scalars['String']['input']>;
  valueComposition_lte?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_contains?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  valueComposition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_starts_with?: InputMaybe<Scalars['String']['input']>;
  valueComposition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  yieldStart?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  yieldStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Vault_OrderBy {
  Decimals = 'decimals',
  DepositCap = 'depositCap',
  FeeApr = 'feeAPR',
  Id = 'id',
  IsTokenPairReversed = 'isTokenPairReversed',
  LastTimeCollect = 'lastTimeCollect',
  Parameter = 'parameter',
  Pool = 'pool',
  PoolId = 'pool__id',
  PoolSqrtPrice = 'pool__sqrtPrice',
  PoolTick = 'pool__tick',
  PoolToken0Price = 'pool__token0Price',
  PoolToken1Price = 'pool__token1Price',
  Rate = 'rate',
  ReceiptTokenUsdValue = 'receiptTokenUSDValue',
  TokenComposition = 'tokenComposition',
  TokenCompositionId = 'tokenComposition__id',
  TokenCompositionLendingToken0 = 'tokenComposition__lendingToken0',
  TokenCompositionLendingToken1 = 'tokenComposition__lendingToken1',
  TokenCompositionPoolToken0 = 'tokenComposition__poolToken0',
  TokenCompositionPoolToken1 = 'tokenComposition__poolToken1',
  TokenCompositionVaultToken0 = 'tokenComposition__vaultToken0',
  TokenCompositionVaultToken1 = 'tokenComposition__vaultToken1',
  TotalAssets = 'totalAssets',
  TotalFeeUsd = 'totalFeeUSD',
  TotalSupply = 'totalSupply',
  Tvl = 'tvl',
  ValueComposition = 'valueComposition',
  ValueCompositionId = 'valueComposition__id',
  ValueCompositionLendingToken0 = 'valueComposition__lendingToken0',
  ValueCompositionLendingToken1 = 'valueComposition__lendingToken1',
  ValueCompositionPoolToken0 = 'valueComposition__poolToken0',
  ValueCompositionPoolToken1 = 'valueComposition__poolToken1',
  ValueCompositionTotalAmountEth = 'valueComposition__totalAmountEth',
  ValueCompositionVaultToken0 = 'valueComposition__vaultToken0',
  ValueCompositionVaultToken1 = 'valueComposition__vaultToken1',
  YieldStart = 'yieldStart'
}

export type WorkingEarnedFee = {
  __typename?: 'WorkingEarnedFee';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  fee0: Scalars['BigInt']['output'];
  fee1: Scalars['BigInt']['output'];
  feeAmountEth: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  token0: Scalars['String']['output'];
  token1: Scalars['String']['output'];
};

export type WorkingEarnedFee_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<WorkingEarnedFee_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fee0?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fee0_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_not?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fee1?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fee1_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_not?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeAmountEth?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  feeAmountEth_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<WorkingEarnedFee_Filter>>>;
  token0?: InputMaybe<Scalars['String']['input']>;
  token0_contains?: InputMaybe<Scalars['String']['input']>;
  token0_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_gt?: InputMaybe<Scalars['String']['input']>;
  token0_gte?: InputMaybe<Scalars['String']['input']>;
  token0_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_lt?: InputMaybe<Scalars['String']['input']>;
  token0_lte?: InputMaybe<Scalars['String']['input']>;
  token0_not?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1?: InputMaybe<Scalars['String']['input']>;
  token1_contains?: InputMaybe<Scalars['String']['input']>;
  token1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_gt?: InputMaybe<Scalars['String']['input']>;
  token1_gte?: InputMaybe<Scalars['String']['input']>;
  token1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_lt?: InputMaybe<Scalars['String']['input']>;
  token1_lte?: InputMaybe<Scalars['String']['input']>;
  token1_not?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkingEarnedFee_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Fee0 = 'fee0',
  Fee1 = 'fee1',
  FeeAmountEth = 'feeAmountEth',
  Id = 'id',
  Token0 = 'token0',
  Token1 = 'token1'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']['output']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type GetPoolQueryQueryVariables = Exact<{
  poolId: Scalars['ID']['input'];
}>;


export type GetPoolQueryQuery = { __typename?: 'Query', pool?: { __typename?: 'Pool', id: string, tick: string, sqrtPrice: string, token0Price: string, token1Price: string, token0: { __typename?: 'Token', id: string, name: string, symbol: string, decimals: string, derivedETH: string }, token1: { __typename?: 'Token', id: string, name: string, symbol: string, decimals: string, derivedETH: string } } | null, bundle?: { __typename?: 'Bundle', ethPriceUSD: string, id: string } | null };

export type GetPoolListQueryQueryVariables = Exact<{
  poolIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetPoolListQueryQuery = { __typename?: 'Query', pools: Array<{ __typename?: 'Pool', id: string, tick: string, sqrtPrice: string, token0Price: string, token1Price: string, token0: { __typename?: 'Token', id: string, name: string, symbol: string, decimals: string, derivedETH: string }, token1: { __typename?: 'Token', id: string, name: string, symbol: string, decimals: string, derivedETH: string } }>, bundle?: { __typename?: 'Bundle', ethPriceUSD: string, id: string } | null };

export type GetPoolListWithBlockNumberQueryQueryVariables = Exact<{
  poolIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  blockNumber?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPoolListWithBlockNumberQueryQuery = { __typename?: 'Query', pools: Array<{ __typename?: 'Pool', id: string, tick: string, sqrtPrice: string, token0Price: string, token1Price: string, token0: { __typename?: 'Token', id: string, name: string, symbol: string, decimals: string, derivedETH: string }, token1: { __typename?: 'Token', id: string, name: string, symbol: string, decimals: string, derivedETH: string } }>, bundle?: { __typename?: 'Bundle', ethPriceUSD: string, id: string } | null };

export type GetTokenListQueryVariables = Exact<{
  tokenAddresses: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetTokenListQuery = { __typename?: 'Query', tokens: Array<{ __typename?: 'Token', id: string, name: string, symbol: string, decimals: string, derivedETH: string }>, bundle?: { __typename?: 'Bundle', ethPriceUSD: string, id: string } | null };


export const GetPoolQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPoolQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poolId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pool"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poolId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tick"}},{"kind":"Field","name":{"kind":"Name","value":"sqrtPrice"}},{"kind":"Field","name":{"kind":"Name","value":"token0"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"derivedETH"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"derivedETH"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token0Price"}},{"kind":"Field","name":{"kind":"Name","value":"token1Price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bundle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"1","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ethPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetPoolQueryQuery, GetPoolQueryQueryVariables>;
export const GetPoolListQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPoolListQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poolIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poolIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tick"}},{"kind":"Field","name":{"kind":"Name","value":"sqrtPrice"}},{"kind":"Field","name":{"kind":"Name","value":"token0"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"derivedETH"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"derivedETH"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token0Price"}},{"kind":"Field","name":{"kind":"Name","value":"token1Price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bundle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"1","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ethPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetPoolListQueryQuery, GetPoolListQueryQueryVariables>;
export const GetPoolListWithBlockNumberQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPoolListWithBlockNumberQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poolIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blockNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poolIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockNumber"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tick"}},{"kind":"Field","name":{"kind":"Name","value":"sqrtPrice"}},{"kind":"Field","name":{"kind":"Name","value":"token0"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"derivedETH"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"derivedETH"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token0Price"}},{"kind":"Field","name":{"kind":"Name","value":"token1Price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bundle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"1","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockNumber"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ethPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetPoolListWithBlockNumberQueryQuery, GetPoolListWithBlockNumberQueryQueryVariables>;
export const GetTokenListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTokenList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenAddresses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenAddresses"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"derivedETH"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bundle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"1","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ethPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetTokenListQuery, GetTokenListQueryVariables>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: string; output: string; }
  BigInt: { input: string; output: string; }
  Bytes: { input: any; output: any; }
  /**
   * 8 bytes signed integer
   *
   */
  Int8: { input: any; output: any; }
  /**
   * A string representation of microseconds UNIX timestamp (16 digits)
   *
   */
  Timestamp: { input: any; output: any; }
};

export enum Aggregation_Interval {
  Day = 'day',
  Hour = 'hour'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type Bundle = {
  __typename?: 'Bundle';
  ethPriceUSD: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
};

export type Bundle_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Bundle_Filter>>>;
  ethPriceUSD?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  ethPriceUSD_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Bundle_Filter>>>;
};

export enum Bundle_OrderBy {
  EthPriceUsd = 'ethPriceUSD',
  Id = 'id'
}

export type Composition = {
  __typename?: 'Composition';
  id: Scalars['ID']['output'];
  lendingToken0: Scalars['BigInt']['output'];
  lendingToken1: Scalars['BigInt']['output'];
  poolToken0: Scalars['BigInt']['output'];
  poolToken1: Scalars['BigInt']['output'];
  vaultToken0: Scalars['BigInt']['output'];
  vaultToken1: Scalars['BigInt']['output'];
};

export type Composition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Composition_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lendingToken0?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lendingToken0_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_not?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken0_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lendingToken1?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lendingToken1_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_not?: InputMaybe<Scalars['BigInt']['input']>;
  lendingToken1_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Composition_Filter>>>;
  poolToken0?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolToken0_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken0_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolToken1?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolToken1_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolToken1_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vaultToken0?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vaultToken0_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_not?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken0_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vaultToken1?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vaultToken1_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_not?: InputMaybe<Scalars['BigInt']['input']>;
  vaultToken1_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Composition_OrderBy {
  Id = 'id',
  LendingToken0 = 'lendingToken0',
  LendingToken1 = 'lendingToken1',
  PoolToken0 = 'poolToken0',
  PoolToken1 = 'poolToken1',
  VaultToken0 = 'vaultToken0',
  VaultToken1 = 'vaultToken1'
}

export type DopexVault = {
  __typename?: 'DopexVault';
  decimals: Scalars['BigInt']['output'];
  depositCap: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  isTokenPairReversed: Scalars['Boolean']['output'];
  pool: Scalars['String']['output'];
  rate: Scalars['BigDecimal']['output'];
  totalAssets: Scalars['BigInt']['output'];
  totalSupply: Scalars['BigInt']['output'];
  yieldStart: Scalars['BigInt']['output'];
};

export type DopexVault_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DopexVault_Filter>>>;
  decimals?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  decimals_lt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_lte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositCap?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositCap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isTokenPairReversed?: InputMaybe<Scalars['Boolean']['input']>;
  isTokenPairReversed_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isTokenPairReversed_not?: InputMaybe<Scalars['Boolean']['input']>;
  isTokenPairReversed_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DopexVault_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  rate_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalAssets?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  yieldStart?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  yieldStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum DopexVault_OrderBy {
  Decimals = 'decimals',
  DepositCap = 'depositCap',
  Id = 'id',
  IsTokenPairReversed = 'isTokenPairReversed',
  Pool = 'pool',
  Rate = 'rate',
  TotalAssets = 'totalAssets',
  TotalSupply = 'totalSupply',
  YieldStart = 'yieldStart'
}

export type GlobalState = {
  __typename?: 'GlobalState';
  dnClassicVaults: Array<Scalars['ID']['output']>;
  dopexAutomaterVaults: Array<Scalars['ID']['output']>;
  ethPriceUSD: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  lpManagers: Array<Scalars['ID']['output']>;
  tvl: Scalars['BigDecimal']['output'];
};

export type GlobalState_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<GlobalState_Filter>>>;
  dnClassicVaults?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_not?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_not_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  dnClassicVaults_not_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_not?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_not_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  dopexAutomaterVaults_not_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  ethPriceUSD?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  ethPriceUSD_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  ethPriceUSD_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_not?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_not_contains?: InputMaybe<Array<Scalars['ID']['input']>>;
  lpManagers_not_contains_nocase?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<GlobalState_Filter>>>;
  tvl?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tvl_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum GlobalState_OrderBy {
  DnClassicVaults = 'dnClassicVaults',
  DopexAutomaterVaults = 'dopexAutomaterVaults',
  EthPriceUsd = 'ethPriceUSD',
  Id = 'id',
  LpManagers = 'lpManagers',
  Tvl = 'tvl'
}

export type HandlerReservedLiquidity = {
  __typename?: 'HandlerReservedLiquidity';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  helper: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  tokenId: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type HandlerReservedLiquidity_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<HandlerReservedLiquidity_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  helper?: InputMaybe<Scalars['String']['input']>;
  helper_contains?: InputMaybe<Scalars['String']['input']>;
  helper_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_ends_with?: InputMaybe<Scalars['String']['input']>;
  helper_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_gt?: InputMaybe<Scalars['String']['input']>;
  helper_gte?: InputMaybe<Scalars['String']['input']>;
  helper_in?: InputMaybe<Array<Scalars['String']['input']>>;
  helper_lt?: InputMaybe<Scalars['String']['input']>;
  helper_lte?: InputMaybe<Scalars['String']['input']>;
  helper_not?: InputMaybe<Scalars['String']['input']>;
  helper_not_contains?: InputMaybe<Scalars['String']['input']>;
  helper_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  helper_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  helper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  helper_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_starts_with?: InputMaybe<Scalars['String']['input']>;
  helper_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<HandlerReservedLiquidity_Filter>>>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
  tokenId_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_gt?: InputMaybe<Scalars['String']['input']>;
  tokenId_gte?: InputMaybe<Scalars['String']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['String']['input']>;
  tokenId_lte?: InputMaybe<Scalars['String']['input']>;
  tokenId_not?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum HandlerReservedLiquidity_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Helper = 'helper',
  Id = 'id',
  Liquidity = 'liquidity',
  TokenId = 'tokenId',
  User = 'user'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Pool = {
  __typename?: 'Pool';
  id: Scalars['ID']['output'];
  sqrtPrice: Scalars['BigInt']['output'];
  tick: Scalars['BigInt']['output'];
  token0: Token;
  token0Price: Scalars['BigDecimal']['output'];
  token1: Token;
  token1Price: Scalars['BigDecimal']['output'];
};

export type Pool_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Pool_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Pool_Filter>>>;
  sqrtPrice?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPrice_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPrice_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tick?: InputMaybe<Scalars['BigInt']['input']>;
  tick_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tick_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tick_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tick_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tick_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tick_not?: InputMaybe<Scalars['BigInt']['input']>;
  tick_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  token0?: InputMaybe<Scalars['String']['input']>;
  token0Price?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  token0Price_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  token0Price_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  token0_?: InputMaybe<Token_Filter>;
  token0_contains?: InputMaybe<Scalars['String']['input']>;
  token0_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_gt?: InputMaybe<Scalars['String']['input']>;
  token0_gte?: InputMaybe<Scalars['String']['input']>;
  token0_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_lt?: InputMaybe<Scalars['String']['input']>;
  token0_lte?: InputMaybe<Scalars['String']['input']>;
  token0_not?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1?: InputMaybe<Scalars['String']['input']>;
  token1Price?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  token1Price_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  token1Price_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  token1_?: InputMaybe<Token_Filter>;
  token1_contains?: InputMaybe<Scalars['String']['input']>;
  token1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_gt?: InputMaybe<Scalars['String']['input']>;
  token1_gte?: InputMaybe<Scalars['String']['input']>;
  token1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_lt?: InputMaybe<Scalars['String']['input']>;
  token1_lte?: InputMaybe<Scalars['String']['input']>;
  token1_not?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Pool_OrderBy {
  Id = 'id',
  SqrtPrice = 'sqrtPrice',
  Tick = 'tick',
  Token0 = 'token0',
  Token0Price = 'token0Price',
  Token0Decimals = 'token0__decimals',
  Token0DerivedEth = 'token0__derivedETH',
  Token0Id = 'token0__id',
  Token0Name = 'token0__name',
  Token0Symbol = 'token0__symbol',
  Token1 = 'token1',
  Token1Price = 'token1Price',
  Token1Decimals = 'token1__decimals',
  Token1DerivedEth = 'token1__derivedETH',
  Token1Id = 'token1__id',
  Token1Name = 'token1__name',
  Token1Symbol = 'token1__symbol'
}

export type Position = {
  __typename?: 'Position';
  id: Scalars['ID']['output'];
  share: Scalars['BigInt']['output'];
  vault: Scalars['String']['output'];
};

export type Position_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Position_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Position_Filter>>>;
  share?: InputMaybe<Scalars['BigInt']['input']>;
  share_gt?: InputMaybe<Scalars['BigInt']['input']>;
  share_gte?: InputMaybe<Scalars['BigInt']['input']>;
  share_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  share_lt?: InputMaybe<Scalars['BigInt']['input']>;
  share_lte?: InputMaybe<Scalars['BigInt']['input']>;
  share_not?: InputMaybe<Scalars['BigInt']['input']>;
  share_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vault?: InputMaybe<Scalars['String']['input']>;
  vault_contains?: InputMaybe<Scalars['String']['input']>;
  vault_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_ends_with?: InputMaybe<Scalars['String']['input']>;
  vault_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_gt?: InputMaybe<Scalars['String']['input']>;
  vault_gte?: InputMaybe<Scalars['String']['input']>;
  vault_in?: InputMaybe<Array<Scalars['String']['input']>>;
  vault_lt?: InputMaybe<Scalars['String']['input']>;
  vault_lte?: InputMaybe<Scalars['String']['input']>;
  vault_not?: InputMaybe<Scalars['String']['input']>;
  vault_not_contains?: InputMaybe<Scalars['String']['input']>;
  vault_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  vault_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  vault_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  vault_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_starts_with?: InputMaybe<Scalars['String']['input']>;
  vault_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Position_OrderBy {
  Id = 'id',
  Share = 'share',
  Vault = 'vault'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  bundle?: Maybe<Bundle>;
  bundles: Array<Bundle>;
  composition?: Maybe<Composition>;
  compositions: Array<Composition>;
  dopexVault?: Maybe<DopexVault>;
  dopexVaults: Array<DopexVault>;
  globalState?: Maybe<GlobalState>;
  globalStates: Array<GlobalState>;
  handlerReservedLiquidities: Array<HandlerReservedLiquidity>;
  handlerReservedLiquidity?: Maybe<HandlerReservedLiquidity>;
  pool?: Maybe<Pool>;
  pools: Array<Pool>;
  position?: Maybe<Position>;
  positions: Array<Position>;
  rebalance?: Maybe<Rebalance>;
  rebalances: Array<Rebalance>;
  reservedLiquidities: Array<ReservedLiquidity>;
  reservedLiquidity?: Maybe<ReservedLiquidity>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
  user?: Maybe<User>;
  users: Array<User>;
  valueComposition?: Maybe<ValueComposition>;
  valueCompositions: Array<ValueComposition>;
  vault?: Maybe<Vault>;
  vaults: Array<Vault>;
  workingEarnedFee?: Maybe<WorkingEarnedFee>;
  workingEarnedFees: Array<WorkingEarnedFee>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryBundleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryBundlesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Bundle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Bundle_Filter>;
};


export type QueryCompositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryCompositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Composition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Composition_Filter>;
};


export type QueryDopexVaultArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDopexVaultsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DopexVault_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DopexVault_Filter>;
};


export type QueryGlobalStateArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryGlobalStatesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GlobalState_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<GlobalState_Filter>;
};


export type QueryHandlerReservedLiquiditiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HandlerReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<HandlerReservedLiquidity_Filter>;
};


export type QueryHandlerReservedLiquidityArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Pool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Pool_Filter>;
};


export type QueryPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Position_Filter>;
};


export type QueryRebalanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRebalancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Rebalance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Rebalance_Filter>;
};


export type QueryReservedLiquiditiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ReservedLiquidity_Filter>;
};


export type QueryReservedLiquidityArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};


export type QueryUserArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryUsersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<User_Filter>;
};


export type QueryValueCompositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryValueCompositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ValueComposition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ValueComposition_Filter>;
};


export type QueryVaultArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryVaultsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Vault_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Vault_Filter>;
};


export type QueryWorkingEarnedFeeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryWorkingEarnedFeesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorkingEarnedFee_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WorkingEarnedFee_Filter>;
};

export type Rebalance = {
  __typename?: 'Rebalance';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  rate: Scalars['BigDecimal']['output'];
  totalAssets: Scalars['BigInt']['output'];
  totalSupply: Scalars['BigInt']['output'];
  vault: Scalars['String']['output'];
};

export type Rebalance_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Rebalance_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Rebalance_Filter>>>;
  rate?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  rate_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalAssets?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vault?: InputMaybe<Scalars['String']['input']>;
  vault_contains?: InputMaybe<Scalars['String']['input']>;
  vault_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_ends_with?: InputMaybe<Scalars['String']['input']>;
  vault_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_gt?: InputMaybe<Scalars['String']['input']>;
  vault_gte?: InputMaybe<Scalars['String']['input']>;
  vault_in?: InputMaybe<Array<Scalars['String']['input']>>;
  vault_lt?: InputMaybe<Scalars['String']['input']>;
  vault_lte?: InputMaybe<Scalars['String']['input']>;
  vault_not?: InputMaybe<Scalars['String']['input']>;
  vault_not_contains?: InputMaybe<Scalars['String']['input']>;
  vault_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  vault_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  vault_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  vault_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  vault_starts_with?: InputMaybe<Scalars['String']['input']>;
  vault_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Rebalance_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  Rate = 'rate',
  TotalAssets = 'totalAssets',
  TotalSupply = 'totalSupply',
  Vault = 'vault'
}

export type ReservedLiquidity = {
  __typename?: 'ReservedLiquidity';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  handler: Scalars['String']['output'];
  helper: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  pool: Scalars['String']['output'];
  tickLower: Scalars['BigInt']['output'];
  tickUpper: Scalars['BigInt']['output'];
  tokenId: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type ReservedLiquidity_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ReservedLiquidity_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper?: InputMaybe<Scalars['String']['input']>;
  helper_contains?: InputMaybe<Scalars['String']['input']>;
  helper_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_ends_with?: InputMaybe<Scalars['String']['input']>;
  helper_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_gt?: InputMaybe<Scalars['String']['input']>;
  helper_gte?: InputMaybe<Scalars['String']['input']>;
  helper_in?: InputMaybe<Array<Scalars['String']['input']>>;
  helper_lt?: InputMaybe<Scalars['String']['input']>;
  helper_lte?: InputMaybe<Scalars['String']['input']>;
  helper_not?: InputMaybe<Scalars['String']['input']>;
  helper_not_contains?: InputMaybe<Scalars['String']['input']>;
  helper_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  helper_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  helper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  helper_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  helper_starts_with?: InputMaybe<Scalars['String']['input']>;
  helper_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ReservedLiquidity_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tickLower?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickLower_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_not?: InputMaybe<Scalars['BigInt']['input']>;
  tickLower_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickUpper?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickUpper_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_not?: InputMaybe<Scalars['BigInt']['input']>;
  tickUpper_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
  tokenId_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_gt?: InputMaybe<Scalars['String']['input']>;
  tokenId_gte?: InputMaybe<Scalars['String']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['String']['input']>;
  tokenId_lte?: InputMaybe<Scalars['String']['input']>;
  tokenId_not?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum ReservedLiquidity_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Handler = 'handler',
  Helper = 'helper',
  Id = 'id',
  Liquidity = 'liquidity',
  Pool = 'pool',
  TickLower = 'tickLower',
  TickUpper = 'tickUpper',
  TokenId = 'tokenId',
  User = 'user'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  bundle?: Maybe<Bundle>;
  bundles: Array<Bundle>;
  composition?: Maybe<Composition>;
  compositions: Array<Composition>;
  dopexVault?: Maybe<DopexVault>;
  dopexVaults: Array<DopexVault>;
  globalState?: Maybe<GlobalState>;
  globalStates: Array<GlobalState>;
  handlerReservedLiquidities: Array<HandlerReservedLiquidity>;
  handlerReservedLiquidity?: Maybe<HandlerReservedLiquidity>;
  pool?: Maybe<Pool>;
  pools: Array<Pool>;
  position?: Maybe<Position>;
  positions: Array<Position>;
  rebalance?: Maybe<Rebalance>;
  rebalances: Array<Rebalance>;
  reservedLiquidities: Array<ReservedLiquidity>;
  reservedLiquidity?: Maybe<ReservedLiquidity>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
  user?: Maybe<User>;
  users: Array<User>;
  valueComposition?: Maybe<ValueComposition>;
  valueCompositions: Array<ValueComposition>;
  vault?: Maybe<Vault>;
  vaults: Array<Vault>;
  workingEarnedFee?: Maybe<WorkingEarnedFee>;
  workingEarnedFees: Array<WorkingEarnedFee>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionBundleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionBundlesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Bundle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Bundle_Filter>;
};


export type SubscriptionCompositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionCompositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Composition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Composition_Filter>;
};


export type SubscriptionDopexVaultArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDopexVaultsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DopexVault_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DopexVault_Filter>;
};


export type SubscriptionGlobalStateArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionGlobalStatesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GlobalState_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<GlobalState_Filter>;
};


export type SubscriptionHandlerReservedLiquiditiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HandlerReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<HandlerReservedLiquidity_Filter>;
};


export type SubscriptionHandlerReservedLiquidityArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Pool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Pool_Filter>;
};


export type SubscriptionPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Position_Filter>;
};


export type SubscriptionRebalanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionRebalancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Rebalance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Rebalance_Filter>;
};


export type SubscriptionReservedLiquiditiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ReservedLiquidity_Filter>;
};


export type SubscriptionReservedLiquidityArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};


export type SubscriptionUserArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionUsersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<User_Filter>;
};


export type SubscriptionValueCompositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionValueCompositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ValueComposition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ValueComposition_Filter>;
};


export type SubscriptionVaultArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionVaultsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Vault_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Vault_Filter>;
};


export type SubscriptionWorkingEarnedFeeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionWorkingEarnedFeesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorkingEarnedFee_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WorkingEarnedFee_Filter>;
};

export type Token = {
  __typename?: 'Token';
  decimals: Scalars['BigInt']['output'];
  derivedETH: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type Token_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  decimals?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  decimals_lt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_lte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  derivedETH?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  derivedETH_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  derivedETH_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Token_OrderBy {
  Decimals = 'decimals',
  DerivedEth = 'derivedETH',
  Id = 'id',
  Name = 'name',
  Symbol = 'symbol'
}

export type User = {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  positions: Array<Position>;
  reservedLiquidities: Array<ReservedLiquidity>;
};


export type UserPositionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Position_Filter>;
};


export type UserReservedLiquiditiesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReservedLiquidity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReservedLiquidity_Filter>;
};

export type User_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<User_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<User_Filter>>>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_?: InputMaybe<Position_Filter>;
  positions_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_not?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  positions_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_?: InputMaybe<ReservedLiquidity_Filter>;
  reservedLiquidities_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_not?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  reservedLiquidities_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum User_OrderBy {
  Id = 'id',
  Positions = 'positions',
  ReservedLiquidities = 'reservedLiquidities'
}

export type ValueComposition = {
  __typename?: 'ValueComposition';
  id: Scalars['ID']['output'];
  lendingToken0: Scalars['BigDecimal']['output'];
  lendingToken1: Scalars['BigDecimal']['output'];
  poolToken0: Scalars['BigDecimal']['output'];
  poolToken1: Scalars['BigDecimal']['output'];
  totalAmountEth: Scalars['BigDecimal']['output'];
  vaultToken0: Scalars['BigDecimal']['output'];
  vaultToken1: Scalars['BigDecimal']['output'];
};

export type ValueComposition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ValueComposition_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lendingToken0?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  lendingToken0_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken0_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  lendingToken1?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  lendingToken1_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  lendingToken1_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ValueComposition_Filter>>>;
  poolToken0?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolToken0_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken0_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolToken1?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolToken1_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolToken1_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalAmountEth?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalAmountEth_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalAmountEth_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  vaultToken0?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  vaultToken0_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken0_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  vaultToken1?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  vaultToken1_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  vaultToken1_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum ValueComposition_OrderBy {
  Id = 'id',
  LendingToken0 = 'lendingToken0',
  LendingToken1 = 'lendingToken1',
  PoolToken0 = 'poolToken0',
  PoolToken1 = 'poolToken1',
  TotalAmountEth = 'totalAmountEth',
  VaultToken0 = 'vaultToken0',
  VaultToken1 = 'vaultToken1'
}

export type Vault = {
  __typename?: 'Vault';
  decimals: Scalars['BigInt']['output'];
  depositCap: Scalars['BigInt']['output'];
  feeAPR: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  isTokenPairReversed: Scalars['Boolean']['output'];
  lastTimeCollect: Scalars['BigInt']['output'];
  parameter: Scalars['String']['output'];
  pool: Pool;
  rate: Scalars['BigDecimal']['output'];
  receiptTokenUSDValue: Scalars['BigDecimal']['output'];
  tokenComposition: Composition;
  totalAssets: Scalars['BigInt']['output'];
  totalFeeUSD: Scalars['BigDecimal']['output'];
  totalSupply: Scalars['BigInt']['output'];
  tvl: Scalars['BigDecimal']['output'];
  valueComposition: ValueComposition;
  yieldStart: Scalars['BigInt']['output'];
};

export type Vault_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Vault_Filter>>>;
  decimals?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_gte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  decimals_lt?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_lte?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not?: InputMaybe<Scalars['BigInt']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositCap?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositCap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositCap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeAPR?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  feeAPR_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAPR_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isTokenPairReversed?: InputMaybe<Scalars['Boolean']['input']>;
  isTokenPairReversed_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isTokenPairReversed_not?: InputMaybe<Scalars['Boolean']['input']>;
  isTokenPairReversed_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  lastTimeCollect?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastTimeCollect_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastTimeCollect_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Vault_Filter>>>;
  parameter?: InputMaybe<Scalars['String']['input']>;
  parameter_contains?: InputMaybe<Scalars['String']['input']>;
  parameter_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_ends_with?: InputMaybe<Scalars['String']['input']>;
  parameter_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_gt?: InputMaybe<Scalars['String']['input']>;
  parameter_gte?: InputMaybe<Scalars['String']['input']>;
  parameter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  parameter_lt?: InputMaybe<Scalars['String']['input']>;
  parameter_lte?: InputMaybe<Scalars['String']['input']>;
  parameter_not?: InputMaybe<Scalars['String']['input']>;
  parameter_not_contains?: InputMaybe<Scalars['String']['input']>;
  parameter_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  parameter_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  parameter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  parameter_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  parameter_starts_with?: InputMaybe<Scalars['String']['input']>;
  parameter_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<Pool_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  rate_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  receiptTokenUSDValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  receiptTokenUSDValue_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  receiptTokenUSDValue_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenComposition?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_?: InputMaybe<Composition_Filter>;
  tokenComposition_contains?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_gt?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_gte?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenComposition_lt?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_lte?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenComposition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenComposition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalAssets?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalFeeUSD?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalFeeUSD_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFeeUSD_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tvl?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tvl_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  valueComposition?: InputMaybe<Scalars['String']['input']>;
  valueComposition_?: InputMaybe<ValueComposition_Filter>;
  valueComposition_contains?: InputMaybe<Scalars['String']['input']>;
  valueComposition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_ends_with?: InputMaybe<Scalars['String']['input']>;
  valueComposition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_gt?: InputMaybe<Scalars['String']['input']>;
  valueComposition_gte?: InputMaybe<Scalars['String']['input']>;
  valueComposition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  valueComposition_lt?: InputMaybe<Scalars['String']['input']>;
  valueComposition_lte?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_contains?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  valueComposition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  valueComposition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  valueComposition_starts_with?: InputMaybe<Scalars['String']['input']>;
  valueComposition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  yieldStart?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  yieldStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  yieldStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Vault_OrderBy {
  Decimals = 'decimals',
  DepositCap = 'depositCap',
  FeeApr = 'feeAPR',
  Id = 'id',
  IsTokenPairReversed = 'isTokenPairReversed',
  LastTimeCollect = 'lastTimeCollect',
  Parameter = 'parameter',
  Pool = 'pool',
  PoolId = 'pool__id',
  PoolSqrtPrice = 'pool__sqrtPrice',
  PoolTick = 'pool__tick',
  PoolToken0Price = 'pool__token0Price',
  PoolToken1Price = 'pool__token1Price',
  Rate = 'rate',
  ReceiptTokenUsdValue = 'receiptTokenUSDValue',
  TokenComposition = 'tokenComposition',
  TokenCompositionId = 'tokenComposition__id',
  TokenCompositionLendingToken0 = 'tokenComposition__lendingToken0',
  TokenCompositionLendingToken1 = 'tokenComposition__lendingToken1',
  TokenCompositionPoolToken0 = 'tokenComposition__poolToken0',
  TokenCompositionPoolToken1 = 'tokenComposition__poolToken1',
  TokenCompositionVaultToken0 = 'tokenComposition__vaultToken0',
  TokenCompositionVaultToken1 = 'tokenComposition__vaultToken1',
  TotalAssets = 'totalAssets',
  TotalFeeUsd = 'totalFeeUSD',
  TotalSupply = 'totalSupply',
  Tvl = 'tvl',
  ValueComposition = 'valueComposition',
  ValueCompositionId = 'valueComposition__id',
  ValueCompositionLendingToken0 = 'valueComposition__lendingToken0',
  ValueCompositionLendingToken1 = 'valueComposition__lendingToken1',
  ValueCompositionPoolToken0 = 'valueComposition__poolToken0',
  ValueCompositionPoolToken1 = 'valueComposition__poolToken1',
  ValueCompositionTotalAmountEth = 'valueComposition__totalAmountEth',
  ValueCompositionVaultToken0 = 'valueComposition__vaultToken0',
  ValueCompositionVaultToken1 = 'valueComposition__vaultToken1',
  YieldStart = 'yieldStart'
}

export type WorkingEarnedFee = {
  __typename?: 'WorkingEarnedFee';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  fee0: Scalars['BigInt']['output'];
  fee1: Scalars['BigInt']['output'];
  feeAmountEth: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  token0: Scalars['String']['output'];
  token1: Scalars['String']['output'];
};

export type WorkingEarnedFee_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<WorkingEarnedFee_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fee0?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fee0_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_not?: InputMaybe<Scalars['BigInt']['input']>;
  fee0_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fee1?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fee1_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_not?: InputMaybe<Scalars['BigInt']['input']>;
  fee1_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeAmountEth?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  feeAmountEth_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeAmountEth_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<WorkingEarnedFee_Filter>>>;
  token0?: InputMaybe<Scalars['String']['input']>;
  token0_contains?: InputMaybe<Scalars['String']['input']>;
  token0_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_gt?: InputMaybe<Scalars['String']['input']>;
  token0_gte?: InputMaybe<Scalars['String']['input']>;
  token0_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_lt?: InputMaybe<Scalars['String']['input']>;
  token0_lte?: InputMaybe<Scalars['String']['input']>;
  token0_not?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1?: InputMaybe<Scalars['String']['input']>;
  token1_contains?: InputMaybe<Scalars['String']['input']>;
  token1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_gt?: InputMaybe<Scalars['String']['input']>;
  token1_gte?: InputMaybe<Scalars['String']['input']>;
  token1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_lt?: InputMaybe<Scalars['String']['input']>;
  token1_lte?: InputMaybe<Scalars['String']['input']>;
  token1_not?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkingEarnedFee_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Fee0 = 'fee0',
  Fee1 = 'fee1',
  FeeAmountEth = 'feeAmountEth',
  Id = 'id',
  Token0 = 'token0',
  Token1 = 'token1'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']['output']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}
